<div class="card text-center billing-card" [ngClass]="{'billing-card-selected': selected}">
  <div class="card-header billing-card-header">
    {{ billingPackage.packageSize }}
  </div>
  <div class="card-body billing-card-body">
    {{ billingPackage.baseCost | rmaCurrency:mainCurrency:'1.0-0' }}
  </div>
  <div class="card-footer billing-card-footer">
    {{ billingPackage.additionalCost | rmaCurrency:mainCurrency:'1.2-2':'right' }}
  </div>
</div>
